import React from "react";
import "./Footer.css";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";
import YouTubeIcon from "@material-ui/icons/YouTube";
import RedditIcon from "@material-ui/icons/Reddit";

function Footer() {
  return (
    <div className="footer">
      <div className="footer__left">
        <h4>
          Designed & Developed by Ali Mehdi <span>🤘</span> 2021
        </h4>
      </div>
      <div className="footer__right">
        <a href="mailto:ali151214.am@outlook.com">
          <EmailOutlinedIcon />
          <span>Email</span>
        </a>
        <a
          href="https://www.instagram.com/witchercodm/"
          target="_blank"
          rel="noreferrer"
        >
          <InstagramIcon />
          <span>Instagram</span>
        </a>
        <a
          href="https://github.com/alimehdiofficial/"
          target="_blank"
          rel="noreferrer"
        >
          <GitHubIcon />
          <span>Github</span>
        </a>
        <a
          href="https://www.youtube.com/channel/UC5XDHSUoBC11Kj-iIpx7QkA"
          target="_blank"
          rel="noreferrer"
        >
          <YouTubeIcon />
          <span>YouTube</span>
        </a>
        <a
          href="https://www.reddit.com/r/reactjs/comments/l5i7mt/i_made_starbucks/"
          target="_blank"
          rel="noreferrer"
        >
          <RedditIcon />
          <span>Reddit</span>
        </a>
      </div>
    </div>
  );
}

export default Footer;
